"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var api_1 = require("../api");
var sound_list_1 = __importDefault(require("../hooks/sound_list"));
require("../scss/app.scss");
var utils_1 = require("../utils");
var button_1 = __importDefault(require("./button"));
var guild_select_1 = __importDefault(require("./guild_select"));
var modal_1 = __importDefault(require("./modal"));
var sound_admin_1 = __importDefault(require("./sound_admin"));
var sound_player_1 = __importDefault(require("./sound_player"));
function AppComponent() {
    var _this = this;
    var _a = (0, react_1.useState)(true), isLoading = _a[0], setIsLoading = _a[1];
    var _b = (0, react_1.useState)(null), error = _b[0], setError = _b[1];
    var _c = (0, react_1.useState)(null), activeModal = _c[0], setActiveModal = _c[1];
    var _d = (0, react_1.useState)(null), activeGuild = _d[0], setActiveGuild = _d[1];
    var _e = (0, react_1.useState)(0), modalHeight = _e[0], setModalHeight = _e[1];
    var _f = (0, react_1.useState)(true), keyPressEnabled = _f[0], setKeyPressEnabled = _f[1];
    var _g = (0, react_1.useState)(true), playerKeyPressEnabled = _g[0], setPlayerKeyPressEnabled = _g[1];
    var soundList = (0, sound_list_1.default)(activeGuild === null || activeGuild === void 0 ? void 0 : activeGuild.id);
    var filterInputRef = (0, react_1.useRef)(null);
    var stopSounds = (0, react_1.useCallback)(function () {
        activeGuild && api_1.api.stopSounds(activeGuild.id);
    }, [activeGuild]);
    var onKeyDown = (0, react_1.useCallback)(function (e) { return __awaiter(_this, void 0, void 0, function () {
        var keybind_1, sound;
        return __generator(this, function (_a) {
            if (!keyPressEnabled)
                return [2 /*return*/];
            switch (e.key) {
                case 's':
                    // stop all sound playback
                    stopSounds();
                    break;
                case 'Escape':
                    // clear filter
                    filterInputRef.current.value = '';
                    soundList.sounds.setFilter('');
                    break;
                default:
                    keybind_1 = soundList.keybinds.get().find(function (keybind) { return keybind.key === e.key; });
                    if (keybind_1) {
                        sound = soundList.sounds.get().find(function (sound) { return sound.id === keybind_1.soundId; });
                        sound && api_1.api.playSound(sound);
                    }
                    break;
            }
            return [2 /*return*/];
        });
    }); }, [keyPressEnabled, activeGuild, soundList]);
    (0, react_1.useEffect)(function () {
        window.addEventListener('keydown', onKeyDown);
        return function () {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [keyPressEnabled, activeGuild, soundList]);
    (0, react_1.useEffect)(function () {
        activeGuild && (0, utils_1.log)("Set active guild to ".concat(activeGuild.id));
    }, [activeGuild]);
    (0, react_1.useEffect)(function () {
        api_1.api.me()
            .then(function (user) {
            (0, utils_1.log)("Logged in as ".concat(user.name, " (").concat(user.id, ")"));
            setIsLoading(false);
        })
            .catch(function (error) {
            if ((0, utils_1.isNotAuthenticatedError)(error)) {
                window.location.href = '/login';
                return;
            }
            setError("".concat(error));
        });
    }, []);
    var onFilter = (0, react_1.useCallback)(function (e) {
        soundList.sounds.setFilter(e.target.value);
    }, [soundList]);
    var onKeyBindSoundSelect = function (sound) {
        setKeyPressEnabled(!sound);
        filterInputRef.current.blur();
        if (sound === null) {
            setPlayerKeyPressEnabled(false);
            setTimeout(function () { return setPlayerKeyPressEnabled(true); }, 1);
        }
    };
    if (error) {
        return (0, jsx_runtime_1.jsx)("div", { className: "error", children: error });
    }
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)("div", { className: "loading", children: "Loading..." });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "app", children: [(0, jsx_runtime_1.jsx)(modal_1.default, { isOpen: activeModal == 'admin', close: function () { return setActiveModal(null); }, onResize: setModalHeight, children: activeGuild && ((0, jsx_runtime_1.jsx)(sound_admin_1.default, { soundList: soundList, guildId: activeGuild.id, height: modalHeight })) }), (0, jsx_runtime_1.jsxs)("div", { className: "header", children: [(0, jsx_runtime_1.jsx)(guild_select_1.default, { onChange: setActiveGuild }), (0, jsx_runtime_1.jsxs)("h1", { children: [(0, jsx_runtime_1.jsx)("img", { src: "/static/favicon.png", alt: "Chompy" }), " Soundboard"] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "options", children: [(0, jsx_runtime_1.jsx)(button_1.default, { label: "Refresh", onClick: function () { return soundList.refresh(); } }), (0, jsx_runtime_1.jsx)(button_1.default, { label: "Stop All [s]", onClick: stopSounds }), (0, jsx_runtime_1.jsx)(button_1.default, { label: "Edit Sounds", onClick: function () { return setActiveModal('admin'); } })] }), (0, jsx_runtime_1.jsx)("div", { className: "filter", children: (0, jsx_runtime_1.jsx)("input", { id: "filter", type: "text", ref: filterInputRef, onFocus: function () { setKeyPressEnabled(false); setPlayerKeyPressEnabled(false); }, onBlur: function () { setKeyPressEnabled(true); setPlayerKeyPressEnabled(true); }, onChange: onFilter, placeholder: 'Filter' }) }), activeGuild && (0, jsx_runtime_1.jsx)(sound_player_1.default, { soundList: soundList, enableKeyBinding: playerKeyPressEnabled, onKeybindSelect: onKeyBindSoundSelect })] }));
}
function App() {
    return (0, jsx_runtime_1.jsx)(AppComponent, {});
}
exports.default = App;
